import React from 'react';
import classNames from 'classnames';
import successImg from 'assets/images/successModalImg.svg';
import { ButtonRect } from 'components';

import { DefaultModalProps } from './types';
import s from '../GameModal.module.scss';
import { useLanguageDirection, useTranslation } from 'appState';

const Success: React.FC<DefaultModalProps> = ({ header, text, onClick }) => {
  const lang = useTranslation('Children');
  const dir = useLanguageDirection();

  return (
    <>
      <div className={s.modal}>
        <div>
          <div className={classNames(s.feedbackIcon, s.success)} />
          <h6 dir={dir}>{ header ?? 'Success!' }</h6>
          <p dir={dir}>{ text ?? 'Click ‘Next’ to start another trial' }</p>
        </div>
        <img className={s.modalImg} src={successImg} alt="Success illustration" />
      </div>
      <ButtonRect
        text={lang.next}
        onClick={onClick}
        isVisible={true}
        className={s.cornerBtn}
      />
    </>
  );
};

export default Success;
